import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const countryStateImporterSelectors = importerSelectors(
  'countryState.importer',
);

export default countryStateImporterSelectors;
